export default __webpack_public_path__ + "static/images/a5f98ee9db8192538ef7792fda291524.svg";